export default __webpack_public_path__ + "static/media/J736MANB2.918ab391.pdf";